import React, { CSSProperties } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { AvailableButtonStyle } from './style';

interface Props {
  onClick: () => void;
  style?: CSSProperties;
  isLoading?: boolean;
  available_days_to_learn?: number;
  disabled?: boolean;
  isCpd?: boolean;
  isFooter?: boolean;
}

const AvailableButton = ({ style, onClick, available_days_to_learn, isLoading, disabled, isCpd, isFooter }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <AvailableButtonStyle
        fullWidth
        style={{ ...style }}
        onClick={onClick}
        loading={isLoading}
        disabled={isLoading || disabled}
        isFooter={isFooter}
      >
        {/* TODO: in the future when move regular course from ruby to react will add more condition */}
        {t('cpd_course.choose_training')}
      </AvailableButtonStyle>
      {isCpd && (
        <Typography
          component="div"
          variant="h7"
          sx={{ mt: { xs: 1, md: 2.5, lg: 1 } }}
          className="text-discount"
          textAlign="center"
        >
          {t('cpd_course.train_within', {
            day: (available_days_to_learn || 0) + 1,
          })}
          &nbsp;(
          {t('cpd_course.selected_training')})
        </Typography>
      )}
    </>
  );
};

export default AvailableButton;
